import * as React from 'react';
import { useRouter } from 'next/router';
import supportedLanguageIds, { SupportedLanguage } from 'lib/lexemes/supported-languages';

// See corresponding unit test for all the test cases
function Link(
    props: React.DetailedHTMLProps<
        React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLAnchorElement
    > & {
        onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    }
) {
    const router = useRouter();
    const [href, setHref] = React.useState(props.href || '');
    // let href = props.href || '';

    React.useEffect(() => {
        if (!href.startsWith('http')) {
            // If link doesn't start with http, log warning and convert to local link
            if (!(href.startsWith('/') || href === '#')) {
                // console.warn('Invalid link. Must be a local or valid http link', href);
                setHref(`/${href}`);
            }

            // 1. If it's a local link
            // 2. There is a language in the url
            // 3. There is no language in the link
            // Then add it
            const language = getLanguageFromUrl(router ? router.asPath : '');
            if (language && !startsWithSupportedLanguage(href)) {
                setHref(`/${language}${href}`);
            }
        }
    }, [href, router]);

    // trim trailing slash for non-root urls
    if (href.length > 1 && href.endsWith('/')) {
        setHref(href.substr(0, href.length - 1));
    }

    return <a {...props} href={href} onClick={props.onClick} />;
}

export default Link;

export function getLanguageFromUrl(urlStr: string) {
    // Filter out empty and dynamic routes
    const split = urlStr
        .split('/')
        .filter((path) => path !== '')
        .filter((path) => !/\[.+?\]/.test(path));

    // extract language
    const splitPart = split.shift();
    if (splitPart && supportedLanguageIds.includes(splitPart as SupportedLanguage)) {
        return splitPart as SupportedLanguage;
    }

    return null;
}

function startsWithSupportedLanguage(url?: string) {
    if (!url) {
        return false;
    }

    return supportedLanguageIds.some((language) => url.startsWith(`/${language}/`));
}
